<ion-app [class.--divide-screen]="displayIntroImage">
    @if (displayIntroImage) {
        <app-introduction-image></app-introduction-image>
    }
    <ion-router-outlet></ion-router-outlet>
</ion-app>
